<div class="table-wrapper-container">
    <!-- Table Card -->
    <div class="table-card">
        <!-- Desktop Table View -->
        <div class="table-responsive hidden md:block">
            <table class="modern-table">
                <thead>
                    <tr>
                        <th [class]="col?.width" *ngFor="let col of columnDef">
                            <div class="flex items-center gap-2">
                                <div class="th-content w-100">
                                    <span class="header-name">{{col.name}}</span>
                                    <input type="text"
                                        class="filter-input"
                                        *ngIf="col?.showInputText"
                                        [disabled]="col.disableSearch"
                                        [value]="filterValues[col?.filterValue] || ''"
                                        [placeholder]="'Search ' + col.name"
                                        (input)="onSearchInputChange($event, col)" />
                                </div>
                                <div *ngIf="col?.isSort" (click)="onSortColumn(col)">
                                    <i [ngClass]="col?.sortOrder === 'ASC' ? 'bi bi-arrow-up' : (col?.sortOrder === 'DESC' ? 'bi bi-arrow-down' : 'bi bi-arrow-down-up')"></i>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="tableData?.length > 0; else noRecords">
                        <tr *ngFor="let row of tableData | paginate : pagingConfig; let i = index; trackBy: trackByRow" class="table-row">
                            <ng-container *ngFor="let col of columnDef">
                                <td [class]="col?.width"
                                    [ngClass]}="{'action-cell-renderer': col?.cellRenderer}"
                                    *ngIf="!col.isNumberField"
                                    title="{{row[col.field] ? col.isObjectTypeField ? row[col.field]?.value : col.isDateTimeField ? (row[col.field] | date: 'MM/dd/YYYY hh:mm a':'America/New_York') : col.isDateField ? (row[col.field] | date: 'MM/dd/YYYY') : row[col.field] : ''}}">
                                    <ng-container *ngIf="col?.isHyperLink; else showTemplateRef">
                                        <a class="table-link" (click)="onClick(row)">
                                            {{ col?.hyperLinkText ? col?.hyperLinkText : row[col.field] ? row[col.field] : '-' }}
                                        </a>
                                    </ng-container>

                                    <ng-template #showTemplateRef>
                                        <ng-container *ngIf="col?.cellRenderer; else showText">
                                            <ng-container [ngTemplateOutlet]="frameworkComponents[col?.cellRenderer]"
                                                [ngTemplateOutletContext]="{$implicit: row, col}"></ng-container>
                                        </ng-container>
                                        <ng-template #showText>
                                            <ng-container *ngIf="col.isObjectTypeField; else showTextField">
                                                {{ col.objectTypeFieldName ? row[col.field]?.[col.objectTypeFieldName] : row[col.field]?.value ? row[col.field]?.value : '-' }}
                                            </ng-container>
                                            <ng-template #showTextField>
                                                {{ col?.isDateTimeField ? (row[col.field] | date: 'MM/dd/YYYY hh:mm a':'America/New_York') : col?.isDateField ? (row[col.field] | date: 'MM/dd/YYYY') : row[col.field] ? row[col.field] : '-' }}
                                            </ng-template>
                                        </ng-template>
                                    </ng-template>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Mobile Card View -->
        <div class="mobile-cards md:hidden">
            <ng-container *ngIf="tableData?.length > 0; else noRecords">
                <div *ngFor="let row of tableData | paginate : pagingConfig; let i = index; trackBy: trackByRow" class="mobile-card">
                    <div *ngFor="let col of columnDef" class="mobile-card-row" [ngClass]="{'action-cell': col?.cellRenderer}">
                        <div class="mobile-card-label">{{ col.name }}</div>
                        <div class="mobile-card-value">
                            <ng-container *ngIf="col?.isHyperLink; else showTemplateRefMobile">
                                <a class="table-link" (click)="onClick(row)">
                                    {{ col?.hyperLinkText ? col?.hyperLinkText : row[col.field] ? row[col.field] : '-' }}
                                </a>
                            </ng-container>

                            <ng-template #showTemplateRefMobile>
                                <ng-container *ngIf="col?.cellRenderer; else showTextMobile">
                                    <ng-container [ngTemplateOutlet]="frameworkComponents[col?.cellRenderer]"
                                        [ngTemplateOutletContext]="{$implicit: row, col}"></ng-container>
                                </ng-container>
                                <ng-template #showTextMobile>
                                    <ng-container *ngIf="col.isObjectTypeField; else showTextFieldMobile">
                                        {{ col.objectTypeFieldName ? row[col.field]?.[col.objectTypeFieldName] : row[col.field]?.value ? row[col.field]?.value : '-' }}
                                    </ng-container>
                                    <ng-template #showTextFieldMobile>
                                        {{ col?.isDateTimeField ? (row[col.field] | date: 'MM/dd/YYYY hh:mm a':'America/New_York') : col?.isDateField ? (row[col.field] | date: 'MM/dd/YYYY') : row[col.field] ? row[col.field] : '-' }}
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- No Records Template -->
        <ng-template #noRecords>
            <tr>
                <td [attr.colspan]="columnDef?.length" class="no-records-cell">
                    <div class="no-records">
                        <div class="no-records-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                            </svg>
                        </div>
                        <h3 class="no-records-title">No Records Found</h3>
                        <p class="no-records-text">There are no records to display at this time.</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-wrapper">
        <div class="pagination-info">
            <span class="pagination-info-text">
                Showing {{ (pagingConfig.currentPage - 1) * pagingConfig.itemsPerPage + 1 }}
                to {{ (pagingConfig.currentPage * pagingConfig.itemsPerPage) > pagingConfig.totalItems ? pagingConfig.totalItems : (pagingConfig.currentPage * pagingConfig.itemsPerPage) }}
                of {{ pagingConfig.totalItems }} entries
            </span>
        </div>

        <div class="pagination-controls-wrapper">
            <div class="rows-per-page">
                <label class="rows-label" for="noOfRows">Rows per page:</label>
                <select name="noOfRows"
                    id="noOfRows"
                    (change)="onTableSizeChange($event)"
                    class="rows-select">
                    <option *ngFor="let size of tableSize" [ngValue]="size" [selected]="size === pagingConfig.itemsPerPage">
                        {{ size }}
                    </option>
                </select>
            </div>

            <pagination-controls
                class="custom-pagination"
                previousLabel="Previous"
                nextLabel="Next"
                (pageChange)="onTableDataChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>